angular
    .module('quattro.bmbo.account.select-context', [
        'quattro.core.hpls_api_1',
    ])
    .directive('bmboSelectContext', function () {
        return {
            restrict: 'A',
            scope: {
                account: '@',
            },
            controller: 'bmboSelectContextController',
            controllerAs: 'vm',
            template: [
                '<option value="new" translate>ACCOUNT.new_context_id</option>',
                '<option ng-repeat="key in vm.keys" value="{{key}}">{{ key }}</option>',
            ].join(' '),
        };
    })
    .controller('bmboSelectContextController', function ($scope, api) {

        var vm = this;

        api
            .single({
                method: 'context.list',
                params: {
                    account: $scope.account,
                }
            })
            .then(function (result) {
                vm.keys = Object.keys(result);
            });

    });
